<template>
    <div class="cms-container px-2" :class="{ 'dimmed': showFilterModal || showAddUserModal || showDeleteModal }">

        <ToastCMS ref="toast" />

        <!-- ADD USER MODAL -->
        <div v-if="userRole !== 'Admin'" class="restricted-overlay">
            <div class="restricted-box">
                <span class="material-symbols-outlined" style="font-size:48px;">lock</span>
                <p class="mb-0 mt-2">Access Restricted</p>
                <p class="mb-0" style="font-size:0.85rem;">This page is for Admins only.</p>
            </div>
        </div>
        <div v-if="showAddUserModal"
            class="modal-overlay d-flex align-items-center justify-content-center fixed-top w-100 h-100 left-0"
            @mousedown="onOverlayMouseDown" @mouseup="onOverlayMouseUp($event, 'adduser')">
            <div class="modal-content bg-white overflow-hidden" @click.stop>
                <div class="modal-header d-flex justify-content-between align-items-center px-3 py-3">
                    <h2 class="m-0 text-dark">Add User</h2>
                    <button class="text-dark bg-transparent border-0 material-symbols-outlined"
                        @click="closeModal">close</button>
                </div>
                <form class="modal-body" @submit.prevent="addUser">
                    <div class="d-flex align-items-center" style="gap:5px">
                        <div class="w-100">
                            <label for="firstname" class="text-dark">First name</label>
                            <input type="text" id="firstname" v-model="newUser.firstname" class="w-100 text-dark px-1"
                                style="outline:none; height:30px;" required>
                        </div>
                        <div class="w-100">
                            <label for="lastname" class="text-dark">Last name</label>
                            <input type="text" id="lastname" v-model="newUser.lastname" class="w-100 text-dark px-1"
                                style="outline:none; height:30px;" required>
                        </div>
                    </div>
                    <div class="w-100 mt-3">
                        <label for="email" class="text-dark">Email</label>
                        <input type="email" id="email" v-model="newUser.email" class="w-100 text-dark px-1"
                            style="outline:none; height:30px;" required>
                    </div>
                    <div class="w-100 mt-3">
                        <label for="username" class="text-dark">Username</label>
                        <input type="text" id="username" v-model="newUser.username" class="w-100 text-dark px-1"
                            style="outline:none; height:30px;" required>
                    </div>
                    <div class="w-100 mt-3">
                        <label for="password" class="text-dark">Password</label>
                        <input type="password" id="password" v-model="newUser.password" class="w-100 text-dark px-1"
                            style="outline:none; height:30px;" required>
                    </div>
                    <div class="w-100 mt-3">
                        <label for="role" class="text-dark">Role</label>
                        <select id="role" v-model="newUser.role" class="w-100 text-dark px-1"
                            style="outline:none; height:30px;" required>
                            <option value="" selected disabled>-- Choose role --</option>
                            <option value="Admin" class="text-dark">Admin</option>
                            <option value="Editor" class="text-dark">Editor</option>
                        </select>
                    </div>
                    <div class="d-flex justify-content-end mt-4" style='gap:10px;'>
                        <button type="submit" class="vmc-bg-prime-5 rounded px-3 py-1 text-white border-0">
                            Add User
                        </button>
                        <button type="button" class="vmc-bg-prime-4 rounded px-3 py-1 text-white border-0"
                            @click="closeModal">Cancel</button>
                    </div>
                </form>
            </div>
        </div>

        <!-- FILTER MODAL -->
        <div v-if="showFilterModal"
            class="modal-overlay d-flex align-items-center justify-content-center fixed-top w-100 h-100 left-0"
            @mousedown="onOverlayMouseDown" @mouseup="onOverlayMouseUp($event, 'filter')">
            <div class="modal-content bg-white overflow-hidden" @click.stop>
                <div class="modal-header d-flex justify-content-between align-items-center px-3 py-3">
                    <h2 class="m-0 text-dark">Filter</h2>
                    <button class="text-dark bg-transparent border-0 material-symbols-outlined"
                        @click="closeFilterModal">close</button>
                </div>
                <form class="modal-body mt-1" @submit.prevent="applyFilters">
                    <div class="w-100">
                        <label for="newscategory" class="text-dark">Role</label>
                        <select v-model="tempRole" class="w-100 text-dark" id="newscategory"
                            style="outline:none; height:30px;">
                            <option value="" class="text-dark" selected>All</option>
                            <option value="Admin" class="text-dark">Admin</option>
                            <option value="Editor" class="text-dark">Editor</option>
                        </select>
                    </div>
                    <div class="w-100 mt-4">
                        <label for="newsyear" class="text-dark">Date:</label>
                        <input type="date" v-model="tempDate" id="newsyear" class="w-100 text-dark px-1"
                            style="outline:none; height:30px;">
                    </div>
                    <div class="d-flex justify-content-end mt-3" style="gap:10px;">
                        <button type="submit" class="vmc-bg-prime-5 rounded px-3 py-1 text-white border-0">Search
                            Filter</button>
                        <button type="button" class="vmc-bg-prime-4 rounded px-3 py-1 text-white border-0"
                            @click="closeFilterModal">Cancel</button>
                    </div>
                </form>
            </div>
        </div>

        <!-- DELETE MODAL -->
        <div v-if="showDeleteModal"
            class="modal-overlay d-flex align-items-center justify-content-center fixed-top w-100 h-100 left-0"
            @mousedown="onOverlayMouseDown" @mouseup="onOverlayMouseUp($event, 'delete')">
            <div class="modal-content bg-white overflow-hidden" @click.stop>
                <div class="modal-header d-flex justify-content-between align-items-center px-3 py-3">
                    <h2 class="m-0 text-dark">Delete User</h2>
                    <button class="text-dark bg-transparent border-0 material-symbols-outlined"
                        @click="closeModal">close</button>
                </div>
                <div class="modal-body mt-1">
                    <p class="text-dark mb-0">Are you sure you want to delete this user?</p>
                    <p v-if="deleteError" class="text-danger mt-2 mb-0" style="font-size:0.85rem;">{{ deleteError }}</p>
                    <div class="d-flex justify-content-end mt-3" style="gap:10px;">
                        <button type="button" @click="confirmDelete"
                            class="vmc-bg-prime-5 rounded px-3 py-1 text-white border-0">Yes</button>
                        <button type="button" class="vmc-bg-prime-4 rounded px-3 py-1 text-white border-0"
                            @click="closeModal">No</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="d-flex align-items-center justify-content-center">
            <button type="button" @click="openModal('adduser')"
                class="border-0 text-white vmc-bg-prime-4 px-3 py-1 rounded d-flex" style="gap:5px;">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M2 21a8 8 0 0 1 13.292-6" />
                    <circle cx="10" cy="8" r="5" />
                    <path d="M19 16v6" />
                    <path d="M22 19h-6" />
                </svg>
                Add User
            </button>
        </div>

        <div class="search-container d-lg-flex align-items-lg-center justify-content-lg-end px-2" style="gap:10px;">
            <div class="filter">
                <button type="button" @click="openModal('filter')"
                    class="d-flex align-items-center vmc-bg-prime-4 text-white border-0 rounded py-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 24 24" fill="none"
                        stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path
                            d="M10 20a1 1 0 0 0 .553.895l2 1A1 1 0 0 0 14 21v-7a2 2 0 0 1 .517-1.341L21.74 4.67A1 1 0 0 0 21 3H3a1 1 0 0 0-.742 1.67l7.225 7.989A2 2 0 0 1 10 14z" />
                    </svg>
                </button>
            </div>
            <input type="text" v-model="searchQuery" @input="resetPage" placeholder="Search..."
                class="search-bar text-dark p-1" style="outline:none;" />
        </div>

        <div class="table-container overflow-auto mt-2">
            <table class="w-100 min-w-100">
                <thead>
                    <tr>
                        <th class="p-2">Legal Name</th>
                        <th class="p-2">Username</th>
                        <th class="p-2">Email</th>
                        <th class="p-2">Role</th>
                        <th class="p-2">Date Added</th>
                        <th class="p-2">Delete</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(user, index) in paginatedUsers" :key="index" class="border-bottom">
                        <td class="p-2 text-dark">{{ (user.firstname || '') + ' ' + (user.lastname || '') || '—' }}</td>
                        <td class="p-2 text-dark">{{ user.username }}</td>
                        <td class="p-2 text-dark">{{ user.email || '—' }}</td>
                        <td class="p-2 text-dark">{{ user.role || '—' }}</td>
                        <td class="p-2 text-dark">
                            {{ user.date || '—' }}
                            <span v-if="user.time"><br>{{ user.time }}</span>
                        </td>
                        <td class="p-2">
                            <div class="d-flex align-items-center">
                                <button type="button" @click="prepareDelete(user.username)"
                                    class="vmc-bg-prime-5 py-1 rounded border-0 d-flex align-items-center">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 24 24"
                                        fill="none" stroke="#ffffff" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round">
                                        <path d="M10 11v6" />
                                        <path d="M14 11v6" />
                                        <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6" />
                                        <path d="M3 6h18" />
                                        <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
                                    </svg>
                                </button>
                            </div>
                        </td>
                    </tr>
                    <tr v-if="paginatedUsers.length === 0">
                        <td colspan="6" class="text-dark text-center p-2">No data found.</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <hr class="px-0">
        <div class="table-footer" style="padding:0 10px;">
            <div class="d-flex align-items-center justify-content-center">
                <p v-if="filteredUsers.length === 0" style="font-weight:400; color: #212529;">
                    Showing 0 to 0 of 0 entries
                </p>
                <p v-else-if="filteredUsers.length === 1" style="font-weight:400; color: #212529;">
                    Showing 1 to 1 of 1 entry
                </p>
                <p v-else style="font-weight:400; color: #212529;">
                    Showing {{ entryStart }} to {{ entryEnd }} of {{ filteredUsers.length }} entries
                </p>
            </div>
            <div class="d-flex align-items-center justify-content-center">
                <p class="next-previous" @click="firstPage" style="border:none; cursor:pointer;">&#60;&#60;</p>
                <p class="next-previous" @click="prevPage" style="border:none; padding:0 10px; cursor:pointer;">&#60;
                </p>
                <p v-if="paginatedUsers.length === 0" class="mx-2">{{ totalPages }} of {{ totalPages }}</p>
                <p v-else class="mx-2">{{ currentPage }} of {{ totalPages }}</p>
                <p class="next-previous" @click="nextPage" style="border:none; padding:0 10px; cursor:pointer;">&#62;
                </p>
                <p class="next-previous" @click="lastPage" style="border:none; cursor:pointer;">&#62;&#62;</p>
            </div>
        </div>
    </div>
</template>

<script>
import ToastCMS from '../ToastCMS.vue';

export default {
    name: "UsersListsCMS",
    components: { ToastCMS },
    data() {
        return {
            users: [],
            currentPage: 1,
            perPage: 10,
            searchQuery: '',
            showFilterModal: false,
            showAddUserModal: false,
            showDeleteModal: false,
            deleteTarget: null,
            deleteError: '',
            // Initialized date & time logic so reactivity doesn't fail
            newUser: {
                firstname: '',
                lastname: '',
                email: '',
                username: '',
                password: '',
                role: '',
                date: '',
                time: ''
            },
            tempRole: '',
            tempDate: '',
            selectedRole: '',
            selectedDate: '',
            overlayMouseDownOnOverlay: false,
            userRole: localStorage.getItem('vmc_role') || '',
        }
    },
    async mounted() {
        window.addEventListener('keydown', this.onKeyboard);
        await this.loadUsers();
    },
    beforeDestroy() {
        window.removeEventListener('keydown', this.onKeyboard);
    },
    computed: {
        filteredUsers() {
            let result = this.users;
            if (this.searchQuery) {
                const query = this.searchQuery.toLowerCase();
                result = result.filter(user =>
                    (user.username || '').toLowerCase().includes(query) ||
                    (user.email || '').toLowerCase().includes(query)
                );
            }
            if (this.selectedRole) {
                result = result.filter(a => a.role === this.selectedRole);
            }
            if (this.selectedDate) {
                result = result.filter(a => (a.date || '').split(' | ')[0] === this.selectedDate);
            }
            return result;
        },
        paginatedUsers() {
            const start = (this.currentPage - 1) * this.perPage;
            return this.filteredUsers.slice(start, start + this.perPage);
        },
        totalPages() {
            return Math.ceil(this.filteredUsers.length / this.perPage) || 1;
        },
        entryStart() {
            if (this.filteredUsers.length === 0) return 0;
            return (this.currentPage - 1) * this.perPage + 1;
        },
        entryEnd() {
            return Math.min(this.currentPage * this.perPage, this.filteredUsers.length);
        }
    },
    methods: {
        async loadUsers() {
            try {
                const token = localStorage.getItem('vmc_token');
                const response = await fetch(`${process.env.VUE_APP_API_URL}/api/users?_nocache=${new Date().getTime()}`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                if (!response.ok) throw new Error("Failed to fetch users");
                this.users = await response.json();
            } catch (error) {
                console.error("Load users error:", error);
            }
        },

        async addUser() {
            try {
                // Generate timestamp for new user creation
                const now = new Date();
                this.newUser.date = now.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' });
                this.newUser.time = now.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit' });

                const token = localStorage.getItem('vmc_token');
                const response = await fetch(`${process.env.VUE_APP_API_URL}/api/users?_nocache=${new Date().getTime()}`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(this.newUser)
                });

                const data = await response.json();
                if (!response.ok) {
                    this.$refs.toast.showToast(data.message || "Failed to add user.", "error");
                    return;
                }

                // Add to table locally to bypass loading logic while Nodemon reboots
                this.users.unshift({ ...this.newUser });

                this.newUser = { firstname: '', lastname: '', email: '', username: '', password: '', role: 'Admin', date: '', time: '' };
                this.closeModal();
                this.$refs.toast.showToast("User added successfully.", "success");
            } catch (error) {
                console.error("Add user error:", error);
                this.$refs.toast.showToast("Could not connect to server.", "error");
            }
        },

        prepareDelete(username) {
            this.deleteTarget = username;
            this.deleteError = '';
            this.openModal('delete');
        },

        async confirmDelete() {
            if (!this.deleteTarget) return;
            this.deleteError = '';
            try {
                const token = localStorage.getItem('vmc_token');
                const response = await fetch(`${process.env.VUE_APP_API_URL}/api/users/${this.deleteTarget}`, {
                    method: 'DELETE',
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                const data = await response.json();
                if (!response.ok) {
                    this.deleteError = data.message || "Failed to delete user.";
                    this.$refs.toast.showToast(this.deleteError, "error");
                    return;
                }

                // Erase from table locally to bypass loading logic while Nodemon reboots
                this.users = this.users.filter(u => u.username !== this.deleteTarget);

                this.deleteTarget = null;
                this.closeModal();
                this.$refs.toast.showToast("User deleted successfully.", "success");
            } catch (error) {
                this.deleteError = "Could not connect to server.";
                this.$refs.toast.showToast("Could not connect to server.", "error");
                console.error("Delete error:", error);
            }
        },

        nextPage() { if (this.currentPage < this.totalPages) this.currentPage++; },
        prevPage() { if (this.currentPage > 1) this.currentPage--; },
        lastPage() { this.currentPage = this.totalPages; },
        firstPage() { this.currentPage = 1; },
        resetPage() { this.currentPage = 1; },

        closeModal() {
            this.showAddUserModal = false;
            this.showDeleteModal = false;
            this.deleteError = '';
        },
        closeFilterModal() {
            this.showFilterModal = false;
        },
        openModal(type) {
            if (type === 'adduser') this.showAddUserModal = true;
            if (type === 'filter') this.showFilterModal = true;
            if (type === 'delete') this.showDeleteModal = true;
        },
        applyFilters() {
            this.selectedRole = this.tempRole;
            if (this.tempDate) {
                const [year, month, day] = this.tempDate.split('-');
                this.selectedDate = `${month}/${day}/${year}`;
            } else {
                this.selectedDate = '';
            }
            this.currentPage = 1;
            this.closeFilterModal();
        },
        onKeyboard(e) {
            if (e.key === 'Escape') {
                this.showFilterModal = false;
                this.showAddUserModal = false;
                this.showDeleteModal = false;
            }
        },
        onOverlayMouseDown(e) {
            this.overlayMouseDownOnOverlay = e.target.classList.contains('modal-overlay');
        },
        onOverlayMouseUp(e, type) {
            if (this.overlayMouseDownOnOverlay && e.target.classList.contains('modal-overlay')) {
                if (type === 'filter') this.closeFilterModal();
                else this.closeModal();
            }
            this.overlayMouseDownOnOverlay = false;
        },
    },
}
</script>

<style scoped>
hr {
    border-top: 1px solid black;
}

button p,
p {
    color: #212529;
}

.next-previous:disabled {
    background-color: white;
    cursor: not-allowed;
}

.toast-container {
    position: fixed;
    width: 300px;
    top: 20px;
    right: 20px;
    z-index: 9999;
}

hr {
    border-top: 1px solid black;
}

@media (min-width: 330px) {
    .cms-container {
        margin-top: 70px;
    }

    .cms-container.dimmed {
        position: relative;
    }

    .cms-container.dimmed::before {
        content: "";
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.1);
        z-index: 2;
    }

    .table-container {
        max-height: 350px;
        height: 350px;
    }

    table {
        border-collapse: collapse;
        width: 100%;
    }

    thead th {
        position: sticky;
        top: 0;
        background-color: var(--vmc-primary-6);
        color: white;
    }

    tr:nth-child(odd) {
        background-color: #f0f0f0;
    }

    .search-bar {
        width: 100%;
        margin-top: 10px;
    }

    .filter {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: row-reverse;
        margin-top: 10px;
    }

    .modal-overlay {
        background-color: rgba(0, 0, 0, 0.5);
        z-index: 9999;
        overflow-y: auto;
        overscroll-behavior: contain;
    }

    .modal-content {
        border-radius: 8px;
        width: 400px;
        max-width: 90%;
        box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
        animation: slideDown 0.3s ease-out;
    }

    .modal-header {
        background-color: #f5f5f5;
        border-bottom: 1px solid #ddd;
    }

    .modal-header h2 {
        font-size: 1.2rem;
    }

    .modal-body {
        padding: 20px;
    }

    @keyframes slideDown {
        from {
            transform: translateY(-20px);
            opacity: 0;
        }

        to {
            transform: translateY(0);
            opacity: 1;
        }
    }
}

@media (min-width: 768px) {
    .search-bar {
        width: 300px;
    }

    .table-footer {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
}

@media (min-width: 1200px) {
    .cms-container {
        margin-left: 310px;
        width: calc(100% - 310px);
        margin-top: 105px;
    }
}

.restricted-overlay {
    position: fixed;
    top: 70px;
    /* below mobile header */
    left: 0;
    right: 0;
    bottom: 0;
    backdrop-filter: blur(6px);
    -webkit-backdrop-filter: blur(6px);
    background-color: rgba(0, 0, 0, 0.3);
    z-index: 50;
    /* below header z-index:99 and sidebar */
    display: flex;
    align-items: center;
    justify-content: center;
}

@media (min-width: 1200px) {
    .restricted-overlay {
        top: 82px;
        /* below desktop header */
        left: 310px;
        /* right of sidebar */
    }
}

.restricted-box {
    background: white;
    border-radius: 12px;
    padding: 30px 40px;
    text-align: center;
    color: #212529;
    box-shadow: 0 5px 20px rgba(0, 0, 0, 0.2);
}
</style>